// extracted by mini-css-extract-plugin
module.exports = {"app":"app_2HnWy","pageHeader":"pageHeader_1dy5l","pageFooter":"pageFooter_33xAj","mainContent":"mainContent_CUBLC"};